import { InfoIcon, RotateCw } from 'lucide-react';

import Turn from './Turn';

import { isHelpAssistantUnavailable } from '@/app/helpArticle/_helpers';

import { Alert, AlertDescription, AlertTitle } from '@/app/ui/alert';
import { Button } from '@/app/ui/button';
import { Error } from '@/app/ui/error';

/**
 * A question that got no answer. A 503 means the assistant is switched off or
 * cannot reach its model, which is said plainly and pointed at search, since
 * the articles themselves are still there. Anything else is an error.
 */
const Failure = ({ error, onRetry }) => {
  if (isHelpAssistantUnavailable(error)) {
    return (
      <Turn data-testid="help-assistant-unavailable">
        <Alert>
          <InfoIcon />
          <AlertTitle>The assistant is taking a break</AlertTitle>
          <AlertDescription>
            <p>It can&apos;t answer questions right now. Try again in a few minutes, or search the help centre in the meantime.</p>
            <RetryButton onRetry={onRetry} />
          </AlertDescription>
        </Alert>
      </Turn>
    );
  }

  return (
    <Turn>
      <Error message={error.message} dataTestId="help-assistant-error" />
      <RetryButton onRetry={onRetry} />
    </Turn>
  );
};

const RetryButton = ({ onRetry }) => {
  return (
    <Button variant="outline" size="sm" className="mt-3" onClick={onRetry} data-testid="help-assistant-retry-button">
      <RotateCw />
      Try Again
    </Button>
  );
};

export default Failure;
